module.exports = __webpack_public_path__ + "img/胡状镇-c.55764847.png";